import React, { useState, useEffect } from "react";
import "./character.css";
import { useLocation, useNavigate } from "react-router-dom";
import { database } from "../../database/firebase";
import { getFirestore, doc, updateDoc, getDoc, setDoc, collection, query, where, getDocs, serverTimestamp } from "firebase/firestore";
import Swal from "sweetalert2"; // Import SweetAlert2 for better UI feedback

function Character({ updateHeader }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [userData, setUserData] = useState(null);
    const [themeData, setThemeData] = useState(null);
    const [selectedCharacter, setSelectedCharacter] = useState(null);
    const [textColor, setTextColor] = useState(null);
    const [alldata, setAllData] = useState(null);
    //const [riddlerusLogo, SetriddlerusLogo] = useState("./img/logo.png");
    const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
    //console.log("storedUserData",storedUserData);

    const characters = [
        { image: "/img/1.png", gif: "/img/1.gif" },
        { image: "/img/2.png", gif: "/img/2.gif" },
        { image: "/img/3.png", gif: "/img/3.gif" },
        { image: "/img/4.png", gif: "/img/4.gif" },
        { image: "/img/5.png", gif: "/img/5.gif" },
    ];

    const handleSuccess = (msg) => {
        Swal.fire({
            icon: "success",
            title: "Success!",
            text: msg,
            customClass: { popup: "custom-success-popup" },
        });
    };

    const handleError = (msg) => {
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: msg,
            customClass: { popup: "custom-success-popup" },
        });
    };

    useEffect(() => {
        updateHeader({ backButtonRedirect: "/intro" });

        const storedSession = sessionStorage.getItem("userData");
        const storedTheme = sessionStorage.getItem("themeData");

        if (storedSession && storedTheme) {
            const parsedTheme = JSON.parse(storedTheme);
            setThemeData(parsedTheme);
            setUserData(JSON.parse(storedSession));
            setTextColor(parsedTheme.landing_page_title_color);
        } else {
            navigate("/login");
        }
    }, [navigate]);

    useEffect(() => {
        if (!userData || !themeData) return;

        const fetchGameData = async () => {
            try {
                const gameRef = doc(
                    database,
                    `sessions/${userData.sessionId}/themes/${themeData.themeName}`
                );
                const docSnapshot = await getDoc(gameRef);

                if (docSnapshot.exists()) {
                    console.log("Game Data:", docSnapshot.data());
                } else {
                    console.warn("Game session document does not exist. Creating one...");

                    // You can add logic here to create a default document if necessary
                }
            } catch (error) {
                console.error("Error fetching game session data:", error);
            }
        };

        fetchGameData();
    }, [userData, themeData]);

    useEffect(() => {
        if (themeData) {
            const body = document.body;

            if (body.classList.contains("common-bg")) {
                body.style.backgroundImage =
                    window.innerWidth <= 768
                        ? `url(${themeData.background_mob})`
                        : `url(${themeData.background_desk})`;
            }
        }
    }, [themeData]);

    useEffect(() => {
        const checkData = async () => {
          if (!storedUserData?.userId || !storedUserData?.sessionId) return;
      
          const reportsRef = collection(database, "alldata");
      
          const queryRef = query(
            reportsRef,
            where("sessionId", "==", storedUserData.sessionId),
            where("userId", "==", storedUserData.userId)
          );
      
          try {
            const querySnapshot = await getDocs(queryRef);
      
            if (!querySnapshot.empty) {
              querySnapshot.forEach((docSnapshot) => {
                const data = docSnapshot.data();
      
                if (data.char) {
                  navigate("/userpage");
                } else {
                  navigate("/character");
                }
              });
            } else {
              // No matching document
              navigate("/character");
            }
          } catch (error) {
            console.error("Error fetching documents:", error);
          }
        };
      
        checkData();
      }, [database, storedUserData, navigate]);
    //   function setSelectedCharacter(charindex){
      
    // }
    
    const NextClick = async () => {
        // Ensure character is selected
        if (!selectedCharacter) {
            handleError("Please select the character");
            return; // Prevent further execution if `selectedchar` is not set
        } else {
            document.querySelector("#nextbtn").style.pointerEvents = "none";
            // Create document reference for the current user
            const alldataCollection = collection(database, 'alldata');

            const alldataQuery = query(
                alldataCollection,
                where("userId", "==", storedUserData.userId),
                where("sessionId", "==", storedUserData.sessionId)
            );

            // Define the async function to handle data operations
            const handleData = async () => {
                try {
                    // Query Firestore to check if the document exists
                    const querySnapshot = await getDocs(alldataQuery);

                    if (querySnapshot.empty) {
                        // If no document exists, create a new one
                        const newDocRef = doc(alldataCollection);

                        // Create the new document
                        await setDoc(newDocRef, {
                            name: storedUserData.name,
                            themeId: themeData?.themeName,
                            organizationId: storedUserData.organizationId,
                            sessionId: storedUserData.sessionId,
                            userId: storedUserData.userId,
                            email: storedUserData.email,
                            totalQuestions: 0,
                            source: storedUserData.source,
                            totalPoints: 0,
                            totalTime: 0,
                            char: (selectedCharacter),
                            selected: false,
                            completed: false,
                            buzzerclick: false,
                            timestamp: serverTimestamp(),
                        });

                        // After document is created, get the document snapshot
                        const docSnapshot = await getDoc(newDocRef);

                        if (docSnapshot.exists()) {
                            console.log('New document created:', docSnapshot.data());
                            sessionStorage.setItem('alldata', docSnapshot.data());
                            setAllData(docSnapshot.data());
                            navigate('/userpage');
                        } else {
                            console.error("Document not found after creation");
                        }
                    } else {
                        // If the document already exists, update it with the selected character
                        const existingDocRef = querySnapshot.docs[0].ref; // Get the first matched document reference
                        await updateDoc(existingDocRef, { char: selectedCharacter });
                        sessionStorage.setItem('alldata', existingDocRef);
                        setAllData(existingDocRef);
                        navigate('/userpage');
                        console.log("Document updated with selected character" + existingDocRef);
                    }
                } catch (error) {
                    console.error("Error during Firestore operation:", error);
                }
            };

            // Execute the data handling function
            await handleData();

        }
    };

    return (
        <div className="maincontent">

            {
                <div className="charactertitle" style={{ textAlign: "center" }}>
                    <h4 id="charactertitle" style={{ color: textColor, "textTransform": "uppercase" }}>Select Your Character</h4>
                </div>
            }
            <div className="char-main-container text-center">
                {characters.map((char, index) => (
                    <div
                        key={index}
                        onClick={() =>{
                            setSelectedCharacter(index+1)
                            //const selectedChar = characters[selectedCharacter];
                            console.log("Selected Character:", index+1);
                            const audio = new Audio(`/sounds/clicksoundeffect.mp3`);
                            audio.play().catch(err => console.error("Audio play failed:", err));
                            
                        }}
                        className="relative inline-block mx-2 cursor-pointer"
                    >
                        <img
                            src={char.image}
                            alt={`Character ${index + 1}`}
                            className="w-16 h-16 rounded-full"
                        />
                        {selectedCharacter === (index+1) && (
                            <span className="tick" id={`tick${index}`}>✔</span>
                        )}
                    </div>
                ))}
            </div>
            {
                <div className="button-container" style={{ textAlign: "center" }}>
                    <button id="nextbtn" onClick={NextClick}>
                        <img src="/img/next.png" className="begin-play-img" alt="Begin Play" />
                    </button>
                </div>
            }
        </div>

    );
}

export default Character;
